export default {
	name: 'faqItem',
	title: 'FAQ Item',
	type: 'document',
	fields: [
		{
			name: 'question',
			title: 'Question',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'answer',
			title: 'Answer',
			type: 'text',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'category',
			title: 'FAQ Category',
			type: 'string',
			options: {
				list: [
					{ title: 'General', value: 'general' },
					{ title: 'Services', value: 'services' },
					{ title: 'Workshops', value: 'workshops' },
					{ title: 'About', value: 'about' },
				],
			},
			initialValue: 'general',
		},
		{
			name: 'order',
			title: 'Display Order',
			type: 'number',
			initialValue: 0,
		},
	],
	preview: {
		select: {
			title: 'question',
			subtitle: 'category',
		},
	},
};
